import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10.666 9.333A1.867 1.867 0 1 0 8.8 11.2v1.6a3.467 3.467 0 1 1 0-6.933 3.467 3.467 0 0 1 0 6.933v-1.6c1.03 0 1.866-.836 1.866-1.867"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10.666 3.467A1.867 1.867 0 1 0 8.8 5.333v1.6A3.467 3.467 0 1 1 8.8 0a3.467 3.467 0 0 1 0 6.933v-1.6c1.03 0 1.866-.835 1.866-1.866"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.333 6.133A1.867 1.867 0 1 0 3.467 8v1.6a3.467 3.467 0 1 1 0-6.933 3.467 3.467 0 0 1 0 6.933V8c1.03 0 1.866-.836 1.866-1.867M17.066 6.4H19.2v5.333h-2.134zM21.866 6.4H24v5.333h-2.134z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M24 5.333v2.134H10.667V5.333z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "key"}) } }